import { ValidateData } from './../../../../core/utils/validate-data';
import { CompanyService } from 'src/app/core/services/company/company.service';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RoutingPath } from 'src/app/configs/routing-path';
import { Parameters } from 'src/app/core/models/disaffiliation/parameters';
import { Body } from 'src/app/core/models/disaffiliation/requests-response';
import { DisaffiliationService } from 'src/app/core/services/disaffiliation/disaffiliation.service';
import { LocalStorageService } from 'src/app/core/services/local-storage/local-storage.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-disaffiliate-process',
  templateUrl: './disaffiliate-process.component.html',
  styleUrls: ['./disaffiliate-process.component.scss']
})
export class DisaffiliateProcessComponent implements OnInit {

  @Input() titleSite: string;
  private requestsResponseBody: Array<Body>;
  private loadingTop: boolean;
  loadingDetail: boolean[] = [];

  constructor(private disaffiliationService: DisaffiliationService,
              private _ROUTER: Router,
              private _STORAGE: LocalStorageService,) { }

  ngOnInit() {
    this.loadingTop = true;
    this.requestsResponseBody = new Array<Body>();
    this.getDataDisaffiliation();
  }

  getDataDisaffiliation(){
    const firstDay = new Date();
    const lastDay = new Date();
    firstDay.setDate(firstDay.getDate() - 30);
    lastDay.setDate(lastDay.getDate() + 1);
    const params: Parameters = new Parameters(this._STORAGE);
    params.setPageNumber(1);
    params.setPrefix("RI");
    params.setDateStart(firstDay.toISOString().split('T')[0]);
    params.setDateEnd(lastDay.toISOString().split('T')[0]);
    params.setPageSize(0);
    this.disaffiliationService.getData(params).subscribe(
      res => {
        this.requestsResponseBody = !ValidateData.emptyObject(res.body) ? res.body : new Array<Body>();
        this.loadingTop = false;
        this.requestsResponseBody = this.requestsResponseBody.sort((a, b) => Number(new Date(b.create_at)) - Number(new Date(a.create_at)));
        this.requestsResponseBody = this.requestsResponseBody.slice(0,3);
      },
      (error) => {
        this.requestsResponseBody = new Array<Body>();
        this.loadingTop = false;          //Error callback
        console.error('error caught in component error: ' + error.message);
      }
    );
  }

  getRequestsResponseBody(): Array<Body> {
    return this.requestsResponseBody;
  }

  getLoadingTop():boolean {
    return this.loadingTop;
  }

  openLink() {
    let url = `/${RoutingPath.appRouting.components.disaffiliate_query.path}/`;
    url += RoutingPath.appRouting.components.disaffiliate_query.pages.query_request.path;
    this._ROUTER.navigate([url, "retiro"]);
  }

  showElement(process: Body, index: number) {
    this.loadingDetail[index] = false;
    let url = `/${RoutingPath.appRouting.components.disaffiliate_query.path}/`;
    url += RoutingPath.appRouting.components.disaffiliate_query.pages.detail.path;
    this._STORAGE.stringifyItem(environment.LOCAL_STORAGE.DESAFILIACION_INFORMACION, process);
    this._ROUTER.navigate([url, "retiro"]);
  }

  generatedExcel(process: Body, index: number) {
    if(process.state === 1){
      return;
    }
    this.disaffiliationService.getExcelAffiliationMas(process.code,process.create_at).subscribe(
      res => {
        const auxLink = document.createElement('a');
        document.body.appendChild(auxLink);
        const url = `data:application/vnd.ms-excel;base64,${res}`;
        auxLink.href = url;
        auxLink.target = '_blank';
        auxLink.hidden = true;
        auxLink.setAttribute("aria-label", "true");
        auxLink.download = `${process.code}.xls`;
        auxLink.click();
        window.URL.revokeObjectURL(url);
        this.loadingDetail[index] = false;
      }
    );
  }

}
